import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const ShowUserInfo = ({ platformUrl }) => {
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    // Extract search parameters from the URL
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userUuid = queryParams.get("uuid");
    const accessToken = queryParams.get("token");

    useEffect(() => {
        const fetchUserInfo = async () => {
            if (!userUuid || !accessToken) {
                setError("Missing UUID or token in search parameters.");
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError("");

                // Fetch user information from Blackboard API
                const response = await axios.get(`${platformUrl}/learn/api/public/v1/users/uuid:${userUuid}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                setUserInfo(response.data);
            } catch (err) {
                console.error("Error fetching user information:", err);
                setError(err.response?.data?.message || "Failed to fetch user information.");
            } finally {
                setLoading(false);
            }
        };

        fetchUserInfo();
    }, [userUuid, accessToken]);

    if (loading) {
        return (
            <div className="loading-container">
                <p>Loading user information...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <p>Error: {error}</p>
            </div>
        );
    }

    return (
        <div className="user-info-container">
            <h2>User Information</h2>
            {userInfo ? (
                <table className="user-info-table">
                    <tbody>
                    <tr>
                        <th>First Name</th>
                        <td>{userInfo.name?.given || "Not Available"}</td>
                    </tr>
                    <tr>
                        <th>Last Name</th>
                        <td>{userInfo.name?.family || "Not Available"}</td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td>{userInfo.contact?.email || "Not Available"}</td>
                    </tr>
                    <tr>
                        <th>Cell Phone</th>
                        <td>{userInfo.contact?.mobilePhone || "Not Available"}</td>
                    </tr>
                    </tbody>
                </table>
            ) : (
                <p>No user information available</p>
            )}
        </div>
    );
};

export default ShowUserInfo;
